import { useState, useEffect } from "react";
import { X, Download, Smartphone } from "lucide-react";
import { Button } from "./ui/button";
import { promptInstall, isInstalled } from "../serviceWorkerRegistration";

export default function PWAInstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if already installed or dismissed
    if (isInstalled() || localStorage.getItem('pwa-prompt-dismissed')) {
      return;
    }

    const handleInstallAvailable = () => {
      setShowPrompt(true);
    };

    const handleInstalled = () => {
      setShowPrompt(false);
    };

    window.addEventListener('sw-install-available', handleInstallAvailable);
    window.addEventListener('sw-installed', handleInstalled);

    // Check if prompt is already available
    if (window.deferredPrompt) {
      setShowPrompt(true);
    }

    return () => {
      window.removeEventListener('sw-install-available', handleInstallAvailable);
      window.removeEventListener('sw-installed', handleInstalled);
    };
  }, []);

  const handleInstall = async () => {
    try {
      const installed = await promptInstall();
      if (installed) {
        setShowPrompt(false);
      }
    } catch (err) {
      console.log('Install prompt error:', err);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    setShowPrompt(false);
    localStorage.setItem('pwa-prompt-dismissed', 'true');
  };

  if (!showPrompt || dismissed) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-slate-900 text-white rounded-xl shadow-2xl p-4 z-50 border border-slate-700 animate-in slide-in-from-bottom-4">
      <button 
        onClick={handleDismiss}
        className="absolute top-2 right-2 p-1 hover:bg-slate-800 rounded"
      >
        <X className="w-4 h-4" />
      </button>
      
      <div className="flex items-start gap-3">
        <div className="p-2 bg-teal-600 rounded-lg">
          <Smartphone className="w-6 h-6" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-sm">Install Operon</h3>
          <p className="text-xs text-slate-400 mt-1">
            Add to your home screen for quick access and offline support
          </p>
          <Button 
            onClick={handleInstall}
            size="sm"
            className="mt-3 w-full bg-teal-600 hover:bg-teal-700 gap-2"
          >
            <Download className="w-4 h-4" />
            Install App
          </Button>
        </div>
      </div>
    </div>
  );
}
